import apiClient from './apiClient';

export const getPassage = (passage_id) => {
    console.log(passage_id);
    return apiClient.get(`/passage/${passage_id}?api_key=1234`);
};